const experiences = [
  {
    company: 'Shared Services Canada',
    role: 'Software Support Analyst',
    period: 'May 2024 – Present',
    responsibilities:
      'Provided technical support for Power Apps and Power BI, developed interactive dashboards using PowerPlatform.',
  },
  {
    company: 'Ville de Laval',
    role: 'IT Intern',
    period: 'Winter 2023',
    responsibilities: 'Integrated AI solutions into existing systems and provided technical analysis.',
  },
  {
    company: 'Delight Canada',
    role: 'Software Developer',
    period: 'Summer 2022',
    responsibilities:
      'Developed microservices for horticulture lighting systems and enhanced ERP functionalities.',
  },
];

module.exports = { experiences };
